import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import type {IssueViewerSecondaryViewServerQueryQuery} from '@github-ui/server-persisted-queries/types/IssueViewerSecondaryViewServerQuery'

// Broad node derived from the allowlisted `IssueViewerSecondaryViewQuery` generated type, which contains the fields
// `useCanEditSubIssues` reads. Deriving from codegen keeps these shapes in sync automatically when the query changes.
type IssueNode = NonNullable<NonNullable<IssueViewerSecondaryViewServerQueryQuery['repository']>['issue']>

/**
 * The fields `useCanEditSubIssues` reads off an `Issue`. Consumers select these inline and forward the result here.
 *
 * Wrapped in `RelayCompat` because the spreading documents are still Relay-owned; remove it once they migrate.
 */
export type UseCanEditSubIssuesFragment = RelayCompat<
  Pick<IssueNode, 'viewerCanUpdateMetadata'> & {
    readonly repository: Pick<IssueNode['repository'], 'isArchived'>
  }
>

/**
 * Returns true if the current viewer can edit sub-issues for the given issue.
 *
 * Returns false if:
 * - the issue's repository is archived
 * - the current viewer does not have write access for the issue
 *   - note: we check `viewerCanUpdateMetadata` for this to exclude authors of issues without at least a triage role
 * */
export function useCanEditSubIssues(data?: UseCanEditSubIssuesFragment | null) {
  const {viewerCanUpdateMetadata, repository} = data ?? {}
  // Coerce to a real boolean: `viewerCanUpdateMetadata` can be null/undefined, and callers use this as a boolean gate.
  return Boolean(viewerCanUpdateMetadata && !repository?.isArchived)
}
